import { Link } from "react-router-dom";
import { Mail, Globe, Phone } from "lucide-react";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="relative z-10 border-t border-white/10 bg-[#080808] pt-20 pb-10 px-6 lg:px-10">
    <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-12">
      <div className="md:col-span-2">
        <Logo size="md" />
        <p className="text-zinc-500 text-sm mt-6 max-w-md leading-relaxed">
          Expert financial advisory and impartial commercial &amp; civil mediation for lawyers, litigators, counsel and high-net-worth individuals.
        </p>
      </div>
      <div>
        <div className="overline mb-5">Navigate</div>
        <div className="flex flex-col gap-3 text-sm">
          <Link to="/advisory" className="text-zinc-400 hover:text-white transition-colors">Expert Advisory</Link>
          <Link to="/mediation" className="text-zinc-400 hover:text-white transition-colors">Mediation</Link>
          <Link to="/about" className="text-zinc-400 hover:text-white transition-colors">About</Link>
          <Link to="/login" className="text-zinc-400 hover:text-white transition-colors">Client Portal</Link>
        </div>
      </div>
      <div>
        <div className="overline mb-5">Contact</div>
        <div className="flex flex-col gap-3 text-sm text-zinc-400">
          <a href="mailto:paul@tactisresolution.co.uk" className="flex items-center gap-2 hover:text-white transition-colors"><Mail size={14} strokeWidth={1.5} /> paul@tactisresolution.co.uk</a>
          <a href="https://www.tactisresolution.co.uk" className="flex items-center gap-2 hover:text-white transition-colors"><Globe size={14} strokeWidth={1.5} /> www.tactisresolution.co.uk</a>
          <a href="tel:+447980285358" className="flex items-center gap-2 hover:text-white transition-colors" data-testid="footer-call-link"><Phone size={14} strokeWidth={1.5} /> 07980 285358</a>
        </div>
      </div>
    </div>
    <div className="max-w-7xl mx-auto mt-16 pt-8 hairline flex flex-col md:flex-row items-center justify-between gap-4">
      <p className="text-zinc-600 text-xs">© {new Date().getFullYear()} Tactis Expert Advisory &amp; Mediation. All rights reserved.</p>
      <p className="text-zinc-600 text-xs">Chartered Certified Accountant &amp; International Mediator</p>
    </div>
  </footer>
);
